import terminal from './terminal';
export default {
  // SSH
  ...terminal,

  // device
  device_title: 'Device',

  // tab
  device_tab1: 'Device Details',
  device_tab2: 'Remote Operations',
  device_tab3: 'Issues',

  // table
  device_table_current_value: 'Current Value',
  device_table_set_value: 'Set Value',
  device_table_refresh_time: 'Last Refresh Time',
  device_table_status: 'Status',
  device_table_sn: 'SN',
  device_table_name: 'Device Name',
  device_table_model: 'Model',
  device_table_soft_version: 'Software Version',
  device_table_maintainace: 'Maintain Cycle',
  device_table_maintainace_last_time: 'Last Maintain Cycle',
  device_table_belonged_site: 'Belonged Site',
  device_table_install_date: 'Install Date',
  device_table_maintenance_duration: 'Maintain Cycle',
  device_table_unmaintained_time: 'Unmaintained Period',
  device_table_total_runtime: 'Total Runtime',
  device_table_export: 'Export Devices Data',
  device_table_export_message: 'Export failed',
  device_table_export_description:
    'All devices in the list will be exported (if search criteria are not empty, the search results will be exported)',
  device_table_export_loading: 'Exporting, please wait...',
  device_table_import: 'Import Devices',
  device_table_import_description: 'Please upload the file to be imported',
  device_table_import_download: 'Download Import Template',
  device_table_import_loading: 'Importing, please wait...',
  device_table_import_message: 'At least one file must be selected',
  device_table_status_info_title: 'Device Status Description',
  device_table_status_info_content: [
    {
      status: 'Offline',
      description: 'Device is offline',
    },
    {
      status: 'Idle',
      description: 'Device is idle',
    },
    {
      status: 'Running',
      description: 'Device is running',
    },
    {
      status: 'Error',
      description: 'Device error',
    },
    {
      status: 'Maintenance',
      description: 'Device under maintenance',
    },
    {
      status: 'Firmware Update',
      description: 'Device is updating firmware',
    },
    {
      status: 'Disabled',
      description: 'Device is disabled',
    },
    {
      status: 'Firmware Update',
      description: 'Device is updating firmware',
    },
  ],
  device_table_fault_name: 'Fault Name',

  // control
  device_control_type: 'Control Type',
  device_control_remote_title: 'Remote Control Device',
  device_control_remote_tip:
    'Note: Only devices in the same site that support batch operations are supported.',
  device_control_remote: 'Remote Control',
  device_control_text: 'Control',

  // form
  device_form_select_device: 'Select Device',
  device_form_select_type: 'Select a Device',
  device_form_param1: 'Please enter the first parameter',
  device_form_param1_ftp: 'Select Attachment',
  device_form_param2: 'Please enter the second parameter',
  device_form_name_placeholder: 'Please enter the device name',
  device_form_sn_placeholder: 'Please enter the device SN',
  device_form_sn_format_error: 'The device SN format is incorrect',
  device_form_arrive_date_placeholder: 'Please select the device arrival date',
  device_form_install_date_placeholder: 'Please select the device install date',
  device_form_maintenance_duration_placeholder: 'Please enter the mainten Cycle',
  device_form_maintenance_duration_unit: 'Unit: days',
  device_form_select_model_placeholder: 'Please select the device model',
  device_form_icons: 'Device Images',
  device_form_model_extra:
    'Note: You can first select a unified device model, and if the selected device model does not match the actual situation, you can modify it later.',
  device_form_import_batch_error:
    'The imported data is empty, please check whether the format of the imported file is correct.',
  device_form_import_batch_failed: 'Import Failed',
  device_form_import_batch_success: 'Import Successfull',
  device_form_import_name_error: 'Device name already exists',
  device_form_import_sns_error: 'Device SN already exists',

  device_search_customer_label: 'Customer',
  device_search_site_label: 'Site',
  device_search_site_placeholder: 'All Sites',
  device_search_site_placeholder2: 'Please select a site',
  device_search_keyword_placeholder: 'Please enter Name/SN/Software version to search',
  device_search_model_label: 'Device Model',
  device_search_model_placeholder: 'All Models',
  device_search_model_search_placeholder: 'Please enter the model name',

  // msg
  device_msg_busy: 'The device is busy, please try again later',
  device_msg_some_busy: 'Some devices are busy, please try again later',
  device_msg_import_file_error: 'Upload file format error, only JSON files are supported',
  device_msg_set_timeout: 'Setting timeout',
  device_msg_exec_timeout: 'Command execution timeout',
  device_msg_same_value_error: 'Cannot be the same value',

  // confirm
  device_confirm_close_vpn_title: 'Confirm to close VPN?',
  device_confirm_close_vpn_content:
    'All connections dependent on VPN will be disconnected, such as WEBUI, SSH',
  device_confirm_disabled_title: 'Confirm to disable this device?',
  device_confirm_disabled_confirm:
    'After disabling, the device will be disconnected from MBE and cannot be monitored by MBE until it is enabled',
  device_confirm_disabled_multi_title: 'Confirm to disable these devices?',
  device_confirm_disabled_content: 'Device Name: {DeviceName}',
  device_confirm_eanbled_title: 'Confirm to enable this device?',
  device_confirm_eanbled_content: 'Device Name: {DeviceName}',
  device_confirm_delete_title: 'Confirm to delete this device?',
  device_confirm_delete_confirm:
    'After deletion, the device will be removed from MBE and cannot be monitored by MBE',
  device_confirm_command_excute_title: 'Confirm to execute this command?',
  device_confirm_save: 'SN is very important, please check again before saving!',
  device_confirm_save_title: 'Save Confirmation',
  device_confirm_maintain_title: 'Maintain this device',
  device_confirm_maintain_content:
    'After device maintenance, the unmaintained cycle of the device will be reset to 0',

  device_confirm_maintain_content2:
    'After handle, the unmaintained cycle of the device will be reset to 0.',
  device_confirm_maintain_content3:
    'After processing, the unmaintained cycle of of all unhandled devices will be reset to 0.',

  // refresh
  device_refresh_last_by: 'Refresh: ',

  // base info
  device_base_model_title: 'Device Model',
  device_base_info_title: 'Basic Info',
  device_base_info_alarm: 'Alarm',
  device_base_info_alarm_status: 'Alarm Status',
  device_base_info_model: 'Device Model',
  device_base_info_arrival_date: 'Arrival Date',
  device_base_info_create_date_time: 'Created Time',

  // config
  device_config_title: 'Device Config',
  device_config_previous_value: 'Previous Value',

  device_detail_image: 'Device Image',

  device_side_title: 'Device',
  device_side_run: 'Runtime Info',
  device_side_config: 'Config Info',
  device_side_fault: 'Alarm List',
  device_side_logs: 'Device Logs',
  device_side_data_chart: 'Data Charts',

  // Alarm Types
  device_alarm_type_ca: 'CA',
  device_alarm_type_ma: 'MA',
  device_alarm_type_oa: 'OA',
  device_alarm_level: 'Alarm Level',
  device_alarm_name: 'Name',
  device_alarm_time: 'Start Time',
  device_alarm_src: 'Source',

  // Status
  device_status_all: 'All',
  device_status_offline: 'Offline',
  device_status_idle: 'Idle',
  device_status_working: 'Working',
  device_status_faulted: 'Error',
  device_status_maintain: 'Maintain',
  device_status_firewareupdt: 'Firmware Update',
  device_status_disabled: 'Disabled',
  device_status_update: 'Firmware Update',

  // Device Command Execution Result Errors
  // Execution command results, 1 means pending, 2 means success, 3 means failure, 4 means timeout, 5 means offline
  device_control_excute_result_error_list: {
    1: 'Pending',
    2: 'Success',
    3: 'Failure',
    4: 'Timeout',
    5: 'Offline',
  },

  // Control Log Type
  device_control_log_type: {
    1: 'Soft Restart',
    2: 'Hard Restart',
    3: 'Disable System',
    4: 'Disable Connector',
    5: 'FTP Software Upgrade',
    6: 'FTP Log Upload',
    7: 'VPN Start',
    8: 'VPN Stop',
    9: 'Refresh Configuration',
    10: 'Refresh Parameters',
    11: 'Set Parameters',
  },

  device_control_form_ctrlid_error: 'Please select a command',

  // export
  device_export_title: 'Export Configuration',
  device_export_name: 'File Name',
  device_export_name_placeholder: 'Please enter the file name',
  device_export_config_title: 'Export Configuration',
  device_export_params_all: 'Export all configuration information?',
  device_export_detail_base: 'Device Base Information',
  device_export_detail_alarm: 'Device Alarm List',
  device_export_detail_runconfig: 'Device Run Configurations',
  device_export_detail_params: 'Device Parameters',

  // select model
  device_selectModel_title: 'Select Device Model',
  device_selectModel_name_label: 'Device Model',
  device_selectModel_image_label: 'Model Image',
  device_selectModel_error: 'This model cannot be selected',

  // params
  device_params_title: 'Configuration Information',
  device_params_set_title: 'Set Parameters',
  device_params_set_select_label: 'Select Device',
  device_params_set_select_add_device: 'Add Device',
  device_params_logs: 'Configuration Logs',
  device_params_batch_set: 'Batch Set',
  device_params_table_name: 'Configuration Item',
  device_params_table_prevalue: 'Original Value',
  device_params_table_value: 'Changed Value',

  // vpn
  device_vpn_url_label: 'URL',
  device_vpn_dynamic_password: 'Dynamic Password',
  device_vpn_remaining_time: 'Remaining Time',
  device_vpn_period: 'Validity Period',
  device_vpn_period_placeholder: 'Select a validity period',
  device_vpn_period_required_msg: 'Please select a validity period',
  device_vpn_destroy_url: 'Destroy URL',
  device_vpn_destroy_url_success: 'Destroyed successfully',
  device_vpn_destroy_url_failed: 'Destruction failed',
  device_vpn_ssh: 'SSH',
  device_vpn_webui: 'WEBUI',
  device_vpn_webui_open: 'Open Link',
  device_vpn_destroy_ssh: 'Destroy SSH',
  device_vpn_open_ssh: 'Open SSH',
  device_vpn_ssh_connect_title: 'SSH Connection',
  device_vpn_ssh_create_title: 'Create SSH Connection',
  device_vpn_webui_connect_title: 'Remote Device WEB Link',
  device_vpn_webui_create_title: 'Create a WEB Link',
  device_vpn_not_support_error: 'Device does not support remote link',
  device_vpn_not_support: 'Device does not support VPN',
  device_vpn_connect_failed: 'VPN connection failed',
  device_vpn_connect_executing_timeout: 'Device execution timeout',
  device_vpn_connect_device_disable: 'Device is disabled',
  device_vpn_connect_device_offline: 'Device is offline',
  device_vpn_error: 'VPN error, status code: {status}',

  // logs
  device_operation_log_title: 'Operation Log',
  device_ctrl_log_title: 'Control Record',
  device_params_log_title: 'Configuration Record',
  device_params_change_log_title: 'Configuration Item Change',

  // chart
  device_alarm_fault_chart_title: 'Alarm and Fault Statistics',
  device_traffic_history_chart_title: 'Historical Traffic Statistics',
  device_fault_ranking_chart_title: 'Fault Ranking',

  device_name_copy: 'Copy Device Name',
};
